import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AccountService } from '../../../Services/account.service';
import { CommunicationModel, EmailPopupModel, PopupButton, PopupModel, PopupModelReturn, User_Login } from '../../../AllTableClasses';
import { ActivatedRoute, Router } from '@angular/router';
import UserSession from '../../../Config/user-session';
import { NotificationPopupComponent } from '../../Components/notification-popup/notification-popup.component';
import { EmailPopupComponent } from '../../Components/email-popup/email-popup.component';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
//import { LoadingService } from '../../../services/loading.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  user: User_Login = new User_Login();
  loading = false;
  errorMessage = '';
  submitted = false;
  mailtoLink!: string;

  constructor(private accountService: AccountService,
    private router: Router,
    private popupNotificationService: PopupNotificationService,
    private route: ActivatedRoute
    //private loadingService: LoadingService
  ) {
    const email = 'support@wms-it.net';
    const subject = 'Contact Administrator';
    const body = 'I am having issues with:';
    this.mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.user.RememberMe = params['rememberMe'];
    });
    this.memberSessioncheck();
  }

  formSubmit(f: NgForm) {
    this.submitted = true;
    if (f.invalid) {
      return;
    }

    this.errorMessage = '';
    this.accountService.login(this.user, (response) => {
      if (response.Success) {
        UserSession.UserID = response.Data.UserID;
        UserSession.UserGuid = response.Data.UserGuid;
        UserSession.UserFullName = response.Data.UserFullName;
        UserSession.BranchID = response.Data.BranchID;
        UserSession.ProvinceID = response.Data.ProvinceID;
        UserSession.RoleID = response.Data.RoleID;
        this.logIn();
      }
      else
      {
        this.popupNotificationService.showNotifcation('error', response.UserErrorMessage);
      }
    }, (error) => {
      console.log(this.errorMessage, error);
      this.loading = false;
      this.errorMessage = 'An error occurred. Please try again.';
      this.popupNotificationService.showNotifcation('error', this.errorMessage);
    });
  }

  forgotPassword() {
    this.router.navigate(['forgot-password']);
  }

  logIn() {

    const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/scheduler';
    this.router.navigateByUrl(returnUrl);
  }

  public memberSessioncheck() {
    this.accountService.memberSessioncheck((data) => {
      if (data.Success) {
        this.user.UserGuid = data.Data.UserGuid;
        this.user.RememberMe = data.Data.RememberMe;
        if (this.user.UserGuid && this.user.RememberMe) {
          this.LoginByGuid();
        }
      }
    }, (error) => {
      console.error("Error in member session check", error);
    });
  }

  public LoginByGuid() {
    this.accountService.LoginByGuid(this.user.UserGuid, (data) => {
      if (data.Success) {
        UserSession.UserID = data.Data.UserID;
        UserSession.UserGuid = data.Data.UserGuid;
        UserSession.UserFullName = data.Data.UserFullName;
        UserSession.BranchID = data.Data.BranchID;
        UserSession.ProvinceID = data.Data.ProvinceID;
        UserSession.RoleID = data.Data.RoleID;
        this.logIn();
      }
    }, (error) => {
      console.error("Error in LoginWithMemberSessionInfo", error);
    });
  }
}
